export default "__VITE_ASSET__BiGoUUfQ__"